"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackerService = void 0;
var infrastructure_const_1 = require("@src/const/infrastructure.const");
var cash_dom_1 = __importDefault(require("cash-dom"));
var leads_const_1 = require("../const/leads.const");
var backend_services_1 = require("./backend-services");
var inter_communication_service_1 = require("./inter-communication.service");
var object_service_1 = require("./object-service");
// utm_source=google&utm_medium=cpc&utm_campaign=spring_sale&utm_content=ad_variant_1
// utm_source=facebook&utm_medium=social&utm_campaign=product_launch&utm_content=video_ad
var TrackerService = /** @class */ (function () {
    function TrackerService() {
        this.communicationService = object_service_1.ObjectService.getInstance(inter_communication_service_1.InterCommunicationService);
        // private trackVisit(config: SettingsService) {
        //   const currentUrl = window.location.href;
        //   // dont send in .webflow staging domains in prod
        //   if (currentUrl.includes('.webflow.io') && config.get.environment === 'prod') {
        //     return;
        //   }
        //   if (config.get.sendTraffic === true) {
        //     const pageIndex = config.get?.pageIndex;
        //     if (pageIndex !== undefined) {
        //       const key = 'visitorIndex';
        //       const totalPages = 20; // adjust if more pages exist
        //       const visitorData = localStorage.getItem(key);
        //       const splitted: string[] | undefined = visitorData?.split('-');
        //       let visitorIndex: string | undefined = splitted?.[0];
        //       const lastPageIndex: string | undefined = splitted?.[1];
        //       const lastPageVisitTime: string | undefined = splitted?.[2];
        //       const lastPageVisitDuration = lastPageVisitTime ? new Date().getTime() - +lastPageVisitTime : undefined;
        //       const firstVisit = !visitorIndex || visitorIndex.length !== totalPages;
        //       // Initialize if not set
        //       if (firstVisit) {
        //         visitorIndex = '0'.repeat(totalPages);
        //       }
        //       // Check if this page was already visited
        //       if (visitorIndex.charAt(pageIndex) === '0') {
        //         // Mark this page as visited
        //         visitorIndex = visitorIndex.substring(0, pageIndex) + '1' + visitorIndex.substring(pageIndex + 1);
        //         // Send traffic update
        //         const fmsUrl = _GetCloudFunctionUrl('fms', config.get.environment);
        //         betterFetch(fmsUrl + '/visitor/update', {
        //           method: 'POST',
        //           headers: {
        //             'Content-Type': 'application/json',
        //           },
        //           body: JSON.stringify({
        //             tenantKey: config.get.tenantKey,
        //             pageIndex,
        //             lastPageIndex: lastPageIndex ? +lastPageIndex : undefined,
        //             lastPageVisitDuration,
        //             firstVisit,
        //           }),
        //         }).then((data) => console.log('test data', data));
        //       }
        //       localStorage.setItem(key, visitorIndex + '-' + pageIndex + '-' + new Date().getTime().toString());
        //     }
        //   }
        // }
    }
    TrackerService.prototype.loadModule = function (config) {
        var _this = this;
        var _a;
        if ((_a = config.get.funnelConfigId) === null || _a === void 0 ? void 0 : _a.length) {
            // V2
            var sendToBackend = function (event, timePassed) { return __awaiter(_this, void 0, void 0, function () {
                var fmsUrl, response;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            fmsUrl = (0, infrastructure_const_1._GetCloudFunctionUrl)('fms', config.get.environment);
                            return [4 /*yield*/, (0, backend_services_1.betterFetch)(fmsUrl + '/visitor/updateV2', {
                                    method: 'POST',
                                    headers: {
                                        'Content-Type': 'application/json',
                                    },
                                    body: JSON.stringify({
                                        tenantKey: config.get.tenantKey,
                                        event: event,
                                        timePassed: timePassed,
                                        funnelConfigId: config.get.funnelConfigId,
                                    }),
                                })];
                        case 1:
                            response = _a.sent();
                            console.log('tracking response status', response.status);
                            return [2 /*return*/, response];
                    }
                });
            }); };
            var key = "visitorIndexV2:".concat(config.get.tenantKey, ":").concat(config.get.funnelConfigId);
            var currentStatus = localStorage.getItem(key);
            console.log('Current visitor index v2', currentStatus);
            if (!currentStatus || !currentStatus.length) {
                currentStatus = '00000-' + Date.now();
                localStorage.setItem(key, currentStatus);
                sendToBackend('landing', 0);
            }
            // this.communicationService.subscribeGlobally().subscribe(async (data) => {
            //   const status = localStorage.getItem(key);
            //   if (!status) return;
            //   if (window.location.href.includes('.webflow.io') && config.get.environment === 'prod') return;
            //   const [flagsStr, timestampStr] = status.split('-');
            //   let flags = flagsStr.split('');
            //   const previousTime = parseInt(timestampStr, 10);
            //   const now = Date.now();
            //   const timePassed = now - previousTime;
            //   const updateAndSend = async (index: number, event: string) => {
            //     if (flags[index] === '0') {
            //       flags[index] = '1';
            //       const newStatus = flags.join('') + '-' + now;
            //       localStorage.setItem(key, newStatus);
            //       await sendToBackend(event, timePassed);
            //     }
            //   };
            //   if (data.event === 'custom' && data.name === 'studioSelected') {
            //     await updateAndSend(0, 'studioSelected');
            //   } else if (data.event === 'custom' && data.name === 'membershipSelected') {
            //     await updateAndSend(1, 'membershipSelected');
            //   } else if (data.event === 'custom' && data.name === 'addonFinished') {
            //     await updateAndSend(2, 'addonFinished');
            //   }
            //   else if (data.event === 'custom' && data.name === 'leadFinished') {
            //     await updateAndSend(3, 'leadFinished');
            //   } else if (data.event === 'custom' && data.name === 'membershipCompleted') {
            //     await updateAndSend(4, 'membershipCompleted');
            //     const currentStatus = '00000-' + Date.now();
            //     localStorage.setItem(key, currentStatus);
            //   }
            // });
        }
        var firstVisit = localStorage.getItem(leads_const_1._FirstVisit);
        if (!firstVisit) {
            localStorage.setItem(leads_const_1._FirstVisit, new Date().toISOString());
        }
        //this.trackVisit(config);
        (0, cash_dom_1.default)('form').each(function (_, formElement) {
            _this.addUTMParametersToForm((0, cash_dom_1.default)(formElement));
        });
    };
    // async awaitable function, very important we track memberships
    TrackerService.prototype.trackFunnelEvent = function (config, event) {
        return __awaiter(this, void 0, void 0, function () {
            var eventIndexMap, key, now, status, _a, flagsStr, timestampStr, flags, previousTime, index, timePassed, newStatus, fmsUrl, response, error_1;
            var _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (!((_b = config.get.funnelConfigId) === null || _b === void 0 ? void 0 : _b.length) || !((_c = config.get.tenantKey) === null || _c === void 0 ? void 0 : _c.length))
                            return [2 /*return*/];
                        eventIndexMap = {
                            studioSelected: 0,
                            membershipSelected: 1,
                            addonFinished: 2,
                            leadFinished: 3,
                            membershipCompleted: 4,
                        };
                        key = "visitorIndexV2:".concat(config.get.tenantKey, ":").concat(config.get.funnelConfigId);
                        now = Date.now();
                        status = localStorage.getItem(key);
                        if (!(status === null || status === void 0 ? void 0 : status.length)) {
                            status = '00000-' + now;
                            localStorage.setItem(key, status);
                        }
                        if (!status)
                            return [2 /*return*/];
                        _a = status.split('-'), flagsStr = _a[0], timestampStr = _a[1];
                        flags = flagsStr.split('');
                        previousTime = parseInt(timestampStr, 10);
                        if (Number.isNaN(previousTime)) {
                            console.error("Invalid tracking timestamp in localStorage for key \"".concat(key, "\""));
                            return [2 /*return*/];
                        }
                        index = eventIndexMap[event];
                        if (index < 0)
                            return [2 /*return*/];
                        if (flags[index] === '1') {
                            return [2 /*return*/];
                        }
                        timePassed = now - previousTime;
                        flags[index] = '1';
                        newStatus = flags.join('') + '-' + now;
                        localStorage.setItem(key, newStatus);
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 3, , 4]);
                        fmsUrl = (0, infrastructure_const_1._GetCloudFunctionUrl)('fms', config.get.environment);
                        return [4 /*yield*/, (0, backend_services_1.betterFetch)(fmsUrl + '/visitor/updateV2', {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                },
                                body: JSON.stringify({
                                    tenantKey: config.get.tenantKey,
                                    event: event,
                                    timePassed: timePassed,
                                    funnelConfigId: config.get.funnelConfigId,
                                }),
                            })];
                    case 2:
                        response = _d.sent();
                        if (!response.ok) {
                            console.error("Tracking failed for ".concat(event, ": ").concat(response.status));
                            throw new Error("Tracking failed for ".concat(event, ": ").concat(response.status));
                        }
                        if (event === 'membershipCompleted') {
                            localStorage.setItem(key, '00000-' + Date.now());
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _d.sent();
                        // rollback the localStorage change so the event can be retried
                        localStorage.setItem(key, status);
                        console.error("Tracking failed for ".concat(event, ": ").concat(error_1));
                        return [2 /*return*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    TrackerService.prototype.addUTMParametersToForm = function (form) {
        var utmValues = this.getUTMValues();
        // Create and append input fields only if corresponding UTM parameters are available
        leads_const_1._UtmFields.forEach(function (field) {
            if (utmValues[field]) {
                form.append("<input type=\"hidden\" name=\"".concat(field, "_input\" id=\"").concat(field, "_input\" value=\"").concat(utmValues[field], "\">"));
            }
        });
    };
    TrackerService.prototype.getUTMValues = function () {
        var values = this.getUTMFromUrl();
        leads_const_1._UtmFields.forEach(function (utm) {
            if (values[utm]) {
                var oldValue = localStorage.getItem(utm);
                if (oldValue && values[utm] !== oldValue) {
                    //if no old values are stored we set them
                    localStorage.setItem(utm + '_last', values[utm]);
                }
                else {
                    //if no old values are stored we set them
                    localStorage.setItem(utm, values[utm]);
                }
            }
        });
        return values;
    };
    TrackerService.prototype.getUTMFromUrl = function () {
        var urlParams = new URLSearchParams(window.location.search);
        var values = {};
        leads_const_1._UtmFields.forEach(function (field) {
            values[field] = urlParams.get(field);
        });
        return values;
    };
    return TrackerService;
}());
exports.TrackerService = TrackerService;
